import { Routes } from "react-router-dom";
import { appRouteConfig } from "./routeConfig";
import { renderRoutes } from "./renderRoutes";

/**
 * Renders the full application route tree from config.
 * @param {{ routeContext?: Record<string, unknown> }} props
 */
export default function AppRoutes({ routeContext = {} }) {
  return <Routes>{renderRoutes(appRouteConfig, routeContext)}</Routes>;
}
